import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function DetectionPackagePage() {
  const columns = [
    {
      title: 'Package Name',
      dataIndex: 'detection_package_name',
      key: 'detection_package_name',
      sorter: (a, b) => a.detection_package_name.localeCompare(b.detection_package_name)
    },
    {
      title: 'Customer',
      dataIndex: ['customer', 'name'],
      key: 'customer_name',

      sorter: (a, b) => a.customer.name.localeCompare(b.customer.name)
    }
  ];

  const formFields = [
    {
      name: 'detection_package_id',
      label: 'Detection Package ID',
      type: 'textarea',
      placeholder: 'Detection Package ID',
      disabled: true
    },
    {
      name: 'detection_package_name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'Detection Package Name',
      rules: [{ required: true, message: 'Must Enter a Detection Package Name!' }]
    },
    {
      name: 'color',
      label: 'Color',
      type: 'color',
      placeholder: 'Detection Package Color',
      presets: [{
        label: 'Available Colors',
        colors: [
          'rgba(87, 138, 168, 0.5)',
          'rgba(154, 185, 203, 0.5)',
          'rgba(168, 117, 87, 0.5)',
          'rgba(203, 172, 154, 0.5)',
          'rgba(42, 213, 142, 0.5)',
          'rgba(213, 42, 113, 0.5)',
          'rgba(131, 80, 175, 0.5)',
          'rgba(124, 175, 80, 0.5)'
        ],
      }],
    },
    {
      name: 'customer_id',
      label: 'Customer',
      type: 'select',
      optionsEndpoint: '/read/customers',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'customer_id',
      searchable: true,
      rules: [{ required: true, message: 'Must select a customer!' }],
    },
    {
      mode: "multiple",
      allowClear: true,
      name: 'detection_type_ids',
      label: 'Detection Type',
      type: 'select',
      optionsEndpoint: '/read/detectiontypes',
      optionsLabel: ['detection_type_desc'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'detection_type_id',
      searchable: true,
      rules: [{ required: true, message: 'Must select at least one detection type!' }],
    },
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/detectionpackages"
        readEndpoint="read/detectionpackages"
        editEndpoint="update/detectionpackages"
        deleteEndpoint="delete/detectionpackages"
        columns={columns}
        formFields={formFields}
        title="Detection Packages"
      />
    </div>
  );
}